import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav style={navStyles}>
      <ul style={ulStyles}>
        <li style={liStyles}>
          <Link to="/" style={linkStyles}>Kezdőlap</Link>
        </li>
        <li style={liStyles}>
          <Link to="/konnyuszerkezetes" style={linkStyles}>Könnyűszerkezetes házak</Link>
        </li>
        <li style={liStyles}>
          <Link to="/gallery" style={linkStyles}>Galéria</Link>
        </li>
      </ul>
    </nav>
  );
};

// Styles for the navigation menu
const navStyles = {
  padding: '2px',
};

// Styles for the unordered list (vertical layout)
const ulStyles = {
  listStyleType: 'none', // Remove bullet points
  padding: 0,
};

// Styles for each list item
const liStyles = {  
  float: 'left'
};

// Styles for the links
const linkStyles = {
  display: 'block', // Make the link fill the entire list item
  padding: '8px 16px',
  color: '#444',
  textDecoration: 'none',
  textAlign: 'center', // Center align the text
  fontSize: '16px',
};

export default Navbar;